import { formatDate } from '@angular/common';
import { CmpsCardRowProgressData } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { Mi2DataResult } from '../models/mi2-data-result';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

function calculateActualValue(
    score: number,
    threshold1: number,
    threshold2: number,
): string {
    if (score < threshold1) return '0%';
    if (score > threshold2) return '100%';
    return `${Math.round(
        ((score - threshold1) / (threshold2 - threshold1)) * 100,
    )}%`;
}

export function getProgressDataMi2(
    mi2DataResult: Mi2DataResult,
    lastUpdated: Date,
): CmpsCardRowProgressData {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);

    const userLocale = i18nService.locale;

    // Handle potentially nullable values explicitly
    const score = mi2DataResult?.miScoreDataList?.[0]?.actual ?? 0;
    const thresholdOne = mi2DataResult.mi2KpiThreshold?.[0]?.rangeEnd ?? 0;
    const thresholdTwo = mi2DataResult.mi2KpiThreshold?.[1]?.rangeEnd ?? 0;

    return {
        progressBarValues: [
            {
                thresholdValue: `${(thresholdOne as number).toFixed(0)}%`,
                actualValue: `${((score / thresholdOne) * 100).toFixed(0)}%`,
                opportunityColor:
                    mi2DataResult.miScoreDataList?.[0]?.thresholdColor ??
                    undefined,
            },
            {
                thresholdValue: `${(thresholdTwo - thresholdOne).toFixed(0)}%`,
                actualValue: calculateActualValue(
                    score,
                    thresholdOne,
                    thresholdTwo,
                ),
                opportunityColor:
                    mi2DataResult.miScoreDataList?.[0]?.thresholdColor ??
                    undefined,
            },
            {
                thresholdValue: `${(100 - thresholdTwo).toFixed(0)}%`,
                actualValue:
                    score > thresholdTwo
                        ? calculateActualValue(score, thresholdTwo, 100)
                        : '0%',
                opportunityColor:
                    mi2DataResult.miScoreDataList?.[0]?.thresholdColor ??
                    undefined,
            },
        ],
        progressTooltipData: [
            {
                label: translateService.instant(
                    TranslationKeyMap._9923_LAST_UPDATED,
                ),
                value: formatDate(
                    lastUpdated,
                    'MMMM d, YYYY, hh:mm a',
                    userLocale,
                ),
            },
        ],
    };
}
